import clone from "clone";
import { LanguageCode, SurveySegmentation } from "..";


// Provides no validation whatsoever!!
export class SegmentationBuilder
{
    public data:SurveySegmentation;
    constructor(name:string, vals:string[])
    {
        this.data = {
            name,
            values:clone(vals),
            translations:[]
        };
    }

    setDefault(name:string, values:string[])
    {
        this.data.name = name;
        this.data.values = clone(values);
        return this;
    }

    addTranslation(languageCode:LanguageCode, name:string, values:string[])
    {
        this.data.translations.push({
            languageCode,
            name,
            values
        });
        return this;
    }

    setTranslation(languageCode:LanguageCode, name:string, values:string[])
    {
        const translation = this.data.translations.find(t => t.languageCode === languageCode);
        if(translation === undefined)
            throw new Error('invalid languageCode');

        translation.name = name;
        translation.values = clone(values);
        return this;
    }

    removeTranslation(languageCode:LanguageCode)
    {
        this.data.translations = this.data.translations.filter(t => t.languageCode !== languageCode);
        return this;
    }
}